import { useState, useEffect, useRef } from "react";
import SuccessMessage from "../../../components/SuccessMessage";
import Constants from "../../../Constants";
import { RotatingLines } from "react-loader-spinner";
import { isValidHttpUrl } from '../../../services/Util';
import jQuery from "jquery";

export default function MarketoRestCredential(props) {

  const authCodeRef = useRef(null)
  const clientIdRef = useRef(null);
  const clientSecretRef = useRef(null);
  const identityUrlRef = useRef(null);
  const endpointUrlRef = useRef(null);
  const userNameRef = useRef(null);
  const passwordRef = useRef(null);

  const credentialData = props.credentialData;
  const [errorMessages, setErrorMessages] = useState(props.errorMessages);
  const [successMessage, setSuccessMessage] = useState(props.successMessage);
  const [authCode, setAuthCode] = useState(authCodeRef.current?.value);
  const [clientId, setClientId] = useState(clientIdRef.current?.value);
  const [clientSecret, setClientSecret] = useState(clientSecretRef.current?.value);
  const [identityUrl, setIdentityUrl] = useState(identityUrlRef.current?.value);
  const [endpointUrl, setEndpointUrl] = useState(endpointUrlRef.current?.value);
  const [userName, setUserName] = useState(userNameRef.current?.value);
  const [password, setPassword] = useState(passwordRef.current?.value);

  useEffect(() => {
    if (props.errorMessages?.length > 0) {
      setErrorMessages(props.errorMessages)
    }
  }, [props.errorMessages])

  useEffect(()=>{
    if(props.successMessage!==Constants.BLANK){
      setSuccessMessage(props.successMessage);
      setTimeout(function(){
        setSuccessMessage(Constants.BLANK);
        //props.closePopup();
      },5000);
    }
  },[props.successMessage]);

  useEffect(() => {
    const saveCredentialButton = jQuery("#save-credential");
    const validateEloquaCredButton = jQuery("#validate-credential");
    if (props.authCodeMode && authCode?.length > 0) {
      saveCredentialButton?.removeAttr("disabled");
      validateEloquaCredButton?.removeAttr("disabled");
    } else if (clientId?.length > 0 && clientSecret?.length > 0 && identityUrl?.length > 0 && isValidHttpUrl(identityUrl) && endpointUrl?.length > 0 && isValidHttpUrl(endpointUrl) && userName?.length > 0 && password?.length > 0) {
      saveCredentialButton?.removeAttr("disabled");
      validateEloquaCredButton?.removeAttr("disabled");
    } else {
      saveCredentialButton?.attr("disabled",  "true")
      validateEloquaCredButton?.attr("disabled", "true")
    }
  }, [authCode, clientId, clientSecret, identityUrl, endpointUrl, userName, password]);

  const onChnageInputFields = () => {
    setAuthCode(authCodeRef.current?.value);
    setClientId(clientIdRef.current?.value);
    setClientSecret(clientSecretRef.current?.value)
    setIdentityUrl(identityUrlRef.current?.value)
    setEndpointUrl(endpointUrlRef.current?.value)
    setUserName(userNameRef.current?.value)
    setPassword(passwordRef.current?.value)
  }

  return (
    <>
    <div className={props.isValidating ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
        <RotatingLines
          strokeColor="#0096FF"
          strokeWidth="5"
          width="196"
          visible={true}
        />
      </div>
    </div> 

    {errorMessages?.length > 0 &&
      <><span id="marketoRestServerError" className="error text-wrap">
      {errorMessages?.map(error => {
        return (<>{error}</>) 
      })}
      </span><br/></>
    }

    {(successMessage!==undefined && successMessage !== Constants.BLANK)?<SuccessMessage message={successMessage}/>:Constants.BLANK}
      
    {props.authCodeMode ?
      <div className="global-dropdown-block mr-0">
          <label>Device Authorization code</label>
          <div className="global-dropdown-select">
          <input id="marketo-rest-authcode-input" type="text" className="form-control-sm" placeholder="Device Authorization code" 
          ref={authCodeRef} onChange={() => onChnageInputFields()} />                            
          </div>
      </div>
    :
      <>
      <div className="global-dropdown-block mr-0">
        <label>Client ID</label>
        <div className="global-dropdown-select">
          <input id="marketo-client-id-input" type="text" className="form-control-sm" placeholder="Client ID" 
          defaultValue={credentialData?.credentials?.CLIENT_ID} ref={clientIdRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Client Secret</label>
        <div className="global-dropdown-select">
          <input id="marketo-client-secret-input" type="text" className="form-control-sm" placeholder="Client Secret" 
          ref={clientSecretRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Identity Url</label>
        <div className="global-dropdown-select">
          <input id="marketo-identity-url-input" type="text" className="form-control-sm" placeholder="Identity Url" 
          defaultValue={credentialData?.credentials?.IDENTITY_URL} ref={identityUrlRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Endpoint Url</label>
        <div className="global-dropdown-select">
          <input id="marketo-endpoint-url-input" type="text" className="form-control-sm" placeholder="Endpoint Url" 
          defaultValue={credentialData?.credentials?.ENDPOINT_URL} ref={endpointUrlRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Username</label>
        <div className="global-dropdown-select">
          <input id="marketo-rest-username-input" type="text" className="form-control-sm" placeholder="Username" 
          ref={userNameRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      <div className="global-dropdown-block mr-0">
        <label>Password</label>
        <div className="global-dropdown-select">
          <input id="marketo-rest-password-input" type="password" className="form-control-sm" placeholder="Password" 
          ref={passwordRef} onChange={() => onChnageInputFields()} />                            
        </div>
      </div>
      </>
      }
      
    </>
  )
}


